<template>
    <div class="return_record info">
        <slot/>
        <el-table class="table" ref="multipleTable" :data="revisitData" stripe highlight-current-row size="mini" style="min-width: 1200px;" height="100%">
            <el-table-column label="操作" width="80">
                <template v-slot="scope">
                    <i class="operation_edit" v-if="module.indexOf(',customer-visit-edit,')!=-1" @click.stop="edit(scope.row.id)" title="修改"></i>
                    <i class="operation_delete" v-if="module.indexOf(',customer-visit-edit,')!=-1" @click.stop="deleteF(scope.row.id)" title="删除"></i>
                </template>
            </el-table-column>
            <el-table-column prop="visit_time" label="回访时间" width="150"></el-table-column>
            <el-table-column prop="type" label="回访方式" width="120" show-overflow-tooltip>
                <template v-slot="scoped">
                    {{scoped.row.type == 1 ? "电话": scoped.row.type == 2 ? "网络" : "上门"}}
                </template>
            </el-table-column>
            <el-table-column prop="visit_name" label="回访对象" width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="visit_content" label="回访内容" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remind" label="待办提醒" show-overflow-tooltip></el-table-column>
            <el-table-column prop="reminder_date" label="提醒日期" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column prop="result" label="代办结果" show-overflow-tooltip></el-table-column>
        </el-table>
        <div class="pag">
            <pagination v-if="refresh" ref="pagination" :lastpages.sync="pages.last_page" :currentpages.sync="pages.current_page" :all.sync="pages.total" :pagesizes.sync="pages.per_page" @getPage="getPage"></pagination>
        </div>
        <!-- 修改回访 -->
        <div v-if="showReturn">
            <addreturns :show="showReturn" :name="name" type="modify" @modifyClose="handleCloseEmit" @comfirmEvent="handleConfirmEvent"/> 
        </div>     
    </div>
</template>

<script>
import eventBus from '../../../eventBus'

import pagination from '../../../components/pagination' 
import addreturns from '../common/addReturn'
export default {
    components: {
        pagination,
        addreturns
    },
    props:{
        revisitData: {
            type: Array,
            default(){
                return []
            }
        },
        pages: {
            type: Object,
            default(){
                return {
                    last_page: 0,
                    total: 0,
                    current_page: 1,
                    per_page: 20
                }
            }
        }
    },
    data(){
        return {
            module:localStorage.dw_erp_power_code,
            last_page: 1,
            current_page: 1,
            total: 100,
            page: 1,
            per_page: 10,

            showReturn: false,
            refresh: true,

            propsForm: {},
            name: localStorage.getItem('dw_erp_customer_name_workbench'),
            id: null
        }
    },
    methods: {
        edit(id){        
            this.postFunc('erp/customer.visit.info', {id}, res=>{
                localStorage.removeItem('dw_erp_customer_revisit_form')
                localStorage.setItem('dw_erp_customer_revisit_form', JSON.stringify(res.data.data))
                this.showReturn = true
            })
        },
        deleteF(id){
            this.$confirm('此操作将永久删除该条回访信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
             }).then(() => {
                this.postFunc('erp/customer.visit.del',{id}, ()=>{
                    this.$emit('operationEvent')
                    eventBus.$emit("refreshTodoListFrom");
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    })
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })        
            })
           
        },
        getPage(obj){
            this.$emit('pageChangeEvent', obj)
        },
        handleCloseEmit(){
            this.showReturn = false;
        },
        handleConfirmEvent(){
            this.$emit("operationEvent")
        }
    },
    watch:{
        pages(){
            //强制刷新组件
            this.refresh= false
            this.$nextTick(()=>{
                this.refresh = true
            })
        }   
    }
}
</script>

<style lang="scss" scoped>
.return_record{
    display: flex;
    flex-direction: column;
    height: 100%;
    .table{
        flex: 1;
    }
    .pag{
        text-align: center;
    }
}
</style>